import { useState } from "react";
import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import {
  CustomTab,
  CustomTabs,
  HeaderWithButtons,
} from "../components-molecules";
import ReferralCodes from "../components-molecules/ReferralCodes";
import { PromoAndVoucherCodes } from "../components-molecules/PromoAndVoucherCodes";
import { UsedCodes } from "../components-molecules/UsedCodes";
import { clearPromotionCodes } from "../redux/actions/promotionCodes";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

export const PromotionCodes = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState<number>(0);
  
  const PROMO_CODE_TABS = [t('admin.usedCodes'), t('admin.promoAndVoucherCodes'), t('admin.referralCodes')];

  const handleChange = (_: any, newValue: any) => {
    if (tabIndex === newValue) {
      return;
    }
    setTabIndex(newValue);
    dispatch(clearPromotionCodes());
  };

  const renderContent = () => {
    switch (tabIndex) {
      case 0:
        return <UsedCodes />
      case 1:
        return <PromoAndVoucherCodes />
      case 2:
        return <ReferralCodes />
    }
  }

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <HeaderWithButtons
          fullWidthTitle
title={t('admin.promotionAndReferralVoucherCodes')} />
        <div className={classes.tabContainer}>
          <CustomTabs value={tabIndex} onChange={handleChange}>
            {PROMO_CODE_TABS.map((tab: string, idx: number) => (
              <CustomTab key={idx} label={tab} />
            ))}
          </CustomTabs>
        </div>
        {renderContent()}
      </Container>
    </Box>
  )
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  tabContainer: {
    marginTop: "12px",
  },
});
